module.exports = __webpack_public_path__ + "static/media/icon-view.ea6c69b2.svg";